import React, { useState, useEffect } from 'react';
import { MDBDataTable } from 'mdbreact';
import { Form, Col, Row, FormControl, InputGroup } from 'react-bootstrap';
import { Button, Container } from '@mui/material';
import Swal from 'sweetalert2';
import "./User.css";
import Select from "react-select";
import { RiDeleteBinFill } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa6";
import "../../assets/css/custom.css";
import { baseURL } from '../base_url';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import moment from 'moment';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosConfig';

const User = () => {
  const navigate = useNavigate();
  const [DisplyForm, setDisplyForm] = useState(false)
  const [userName, setUserName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [note, setNote] = useState('')
  const [selectedCompany, setSelectedCompany] = useState('')
  const [companyItems, setCompanyItems] = useState([])
  const [roleItems, setRoleItems] = useState([])
  const [selectedRole, setSelectedRole] = useState('')
  const [updateFlag, setUpdateFlag] = useState(false);
  const [accessDetails, setAccessDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(false)
  const [viewEditButton, setViewEditButton] = useState(true)
  const [isEdited, setIsEdited] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [sendMailStatus, setSendMailStatus] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState([])
  const [selectedLocation2, setSelectedLocation2] = useState([])
  const [locationItems, setLocationItems] = useState([])
  const [selectedApiComany, setSelectedApiComany] = useState([])
  const [selectedApiComany2, setSelectedApiComany2] = useState([])
  const allOption = { value: "ALL", label: "Select All" };
    const apiCompanyItems = [
    { label: "STELLANTIS", value: "STELLANTIS" },
    { label: "FORD", value: "FORD" },
    { label: "NISSAN", value: "NISSAN" },
    { label: "VOLKSWAGON", value: "VOLKSWAGON" }
  ];
  const locationOptions = [...locationItems];
  const options = [allOption, ...locationOptions];
  const allApiCompanyOption = { value: "ALL", label: "Select All API Companies" };
  const apiCompanyOptions = [allApiCompanyOption, ...apiCompanyItems];
  const [errors, setErrors] = useState({
    userName: '',
    email: '',
    password: '',
    phoneNumber: '',
  });

  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
  const authToken = foundUser['auth_token'];

  useEffect(() => {
    axios.get(baseURL + "/get_company_setup?status=active&admin_id=" + foundUser['tm_id']).then((res) => {
      const menuList = res.data.data.map((val1) => {
        return { label: val1.company_name, value: val1._id }
      })
      setCompanyItems(menuList)
    });
  },[]);

  useEffect(() => {
    axios.get(baseURL + "/get_access_setup?status=active&admin_id=" + foundUser['tm_id']).then((res) => {
      const menuList = res.data.data.map((val1) => {
        return { label: val1.role_name, value: val1._id }
      })
      setRoleItems(menuList)
    });
  },[]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  const handleLocationChange = (selectedOption) =>{
    setSelectedLocation(selectedOption);
    const ids = selectedOption.map(option => option.value);
    setSelectedLocation2(ids);
    return false;
  }

  useEffect(() => {
    setLoading(true);
    axiosInstance.get(baseURL + "/get_user_setup?admin_id=" + foundUser['tm_id'])
    .then((res) => {
      var j = 1;
      if(res.data.status === '1'){
        let rowsData = [];
        const myDataSet = res.data.data;
        for (var index = 0; index < res.data.data.length; index++) {
          let rowItem = {};
          const val = myDataSet[index];
          rowItem["id"] = j++;
          rowItem["u_name"] = val.user_name;
          rowItem["email"] = val.user_email;
          rowItem["role"] = val.r_name;
          rowItem["c_name"] = val.c_name;
          rowItem['c_date'] = moment(new Date(val.created_date)).format('MM/DD/YYYY hh:mm A');
          rowItem['status'] = (val.is_active === 'True' ? 'Active':'In-Active');
          rowItem['action'] = (<React.Fragment><FaEye title='View' onClick={() => vieweditHandle("view-"+val._id)} style={{ marginLeft: '8px', cursor: 'pointer' }}/> {foundUser['tm_accessRole']['User']['Edit'] == true && (<>|<FaEdit title='Edit' onClick={() => vieweditHandle("edit-"+val._id)} style={{ marginLeft: '8px', cursor: 'pointer' }}/></>)} {foundUser['tm_accessRole']['User']['Delete'] == true && (<>| <RiDeleteBinFill  title='Delete' onClick={() => deleteHandle(val._id)} style={{ cursor: 'pointer' }}/></>)}</React.Fragment>)
          rowsData.push(rowItem)
        }
        setAccessDetails(rowsData);
      }else{
        setAccessDetails([]);
      }
      setLoading(false);
    })
  },[updateFlag, companyItems]);
  
  const vieweditHandle = (id) => {
    setLoading(true);
    const explodedArray = id.split('-');
    axiosInstance.post(baseURL + "/get_user_setup_single",
      {"id":explodedArray[1]}).then((res) => {
      if(res.data.status === '1'){
        setDisplyForm(true)
        handleCompanyChange3(res.data.data.company_id);
        setSelectedCompany(companyItems.find(option => parseInt(option.value) === parseInt(res.data.data.company_id)));
        setSelectedRole(roleItems.find(option => parseInt(option.value) === parseInt(res.data.data.selected_role)))
        setUserName(res.data.data.user_name);
        setEmail(res.data.data.user_email);
        setPassword(res.data.data.password);
        setPhoneNumber(res.data.data.phone_number);
        setSelectedLocation(res.data.data.loc_name);
        setSelectedApiComany(res.data.data.api_comany_name);
        setNote(res.data.data.note);
        if (res.data.data.is_active === 'True'){
          setIsActive(true);
        }else{
          setIsActive(false);
        }
        if (explodedArray[0] === 'view'){
          setViewEditButton(false)
        }else{
          setIsEdited(res.data.data._id)
          setViewEditButton(true)
        }
      }else{
        Swal.fire("Something went wrong.")
        return;
      }
      setLoading(false);
    })
  }

  const deleteHandle = (id) => {
    Swal.fire({
      title: 'Are you sure you want to delete?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(baseURL + "/user_delete",{"id":id,"admin_id":foundUser['tm_id']}).then((res) => {
          if(res.data.status === '1'){
            setUpdateFlag(!updateFlag);
            Swal.fire('Deleted!', 'User has been deleted.', 'success')
          }else{
            Swal.fire("Something went wrong.")
          }
          setLoading(false);
        })
      }
    })
  }
  const handleIsActive = (e) => {
    setIsActive(e.target.checked);
  }
  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(companyItems.find(option => option.value === selectedOption.value))
    axios.get(baseURL + "/get_location_setup?status=active&com_id="+selectedOption.value+"&admin_id=" + foundUser['tm_id']).then((res) => {
      // const allOption = { label: "All", value: "0" };
      const menuList2 = res.data.data.map((val1) => {
        return { label: val1.location_name, value: val1._id }
      })
      // setLocationItems([allOption, ...menuList2])
      setLocationItems(menuList2)
    });
    return false;
  }
  const handleCompanyChange3 = (selectedOption) => {
    setSelectedCompany(companyItems.find(option => option.value === selectedOption))
    axios.get(baseURL + "/get_location_setup?status=active&com_id="+selectedOption+"&admin_id=" + foundUser['tm_id']).then((res) => {
      const menuList2 = res.data.data.map((val1) => {
        return { label: val1.location_name, value: val1._id }
      })
      setLocationItems(menuList2)
    });
    return false;
  }
  const handleCompanyChange2 = (e) => {
    setSelectedRole(roleItems.find(option => option.value === e.value))
    return false;
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    setSelectedCompany("");
    setSelectedRole("");
    setSelectedApiComany([]);
    setSelectedLocation([]);
    setUserName("");
    setEmail("");
    setPassword("");
    setPhoneNumber("");
    setNote("");
    setDisplyForm(true);
    setViewEditButton(true);
    setIsEdited('');
  }
  // const apiCompanyItems = [
  //   { label: "STELLANTIS", value: "STELLANTIS" },
  //   { label: "FORD", value: "FORD" },
  //   { label: "NISSAN", value: "NISSAN" },
  //   { label: "VOLKSWAGON", value: "VOLKSWAGON" }
  // ];
  
  const handleApiCompanyChange = (selectedOption) =>{
    setSelectedApiComany(selectedOption);
    const ids = selectedOption.map(option => option.value);
    setSelectedApiComany2(ids);
    return false;
  }
  const handleSubmitForm = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(selectedCompany.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please select company name.'})
      return;
    }
    if(selectedRole.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please select Role.'})
      return;
    }
    if(userName.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter user name.'})
      return;
    }
    if(email.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter Email-id.'})
      return;
    }
    if (!emailRegex.test(email)){
      Swal.fire({icon: 'error',
                text: 'Please enter valid Email-id.'})
      return;
    }
    if(password.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter Password.'})
      return;
    }
    if(selectedLocation2.length <= 0){
      Swal.fire({icon: 'error',
                text: 'Please Select Atleast One Location.'})
      return;
    }
    if(selectedApiComany2.length <= 0){
      Swal.fire({icon: 'error',
                text: 'Please Select Atleast One API Company.'})
      return;
    }
    setLoading(true);
    axios.post(baseURL + "/create_user", {
      'admin_id': foundUser['tm_id'],
      'company_id': selectedCompany.value,
      'location_id': selectedLocation2,
      'api_comany': selectedApiComany2,
      'role_id': selectedRole.value,
      'user_name':userName.toString(),
      'email':email,
      'password':password.toString(),
      'phone_number':phoneNumber? phoneNumber.toString():"",
      'note':note? note.toString():"",
      'status': isActive,
      'is_edited': isEdited,
      'send_mail':sendMailStatus
    }).then((res) => {
      setLoading(false);
      if (res.data.status === 'success'){
        setDisplyForm(false)
        let msg = userName.toString() + " created successfully.";
        if (sendMailStatus === true){
          msg = userName.toString() + " created successfully. Mail has been sent.";
        }
        Swal.fire({icon: 'success',
          text: msg
        })
      }else if (res.data.status === 'duplicate'){
        Swal.fire("<b>"+email.toString() + "</b> already exist, Please try with different email name.")
        return;
      }else if (res.data.status === 'updated'){
        setDisplyForm(false)
        let msg = userName.toString() + " updated successfully.";
        if (sendMailStatus === true){
          msg = userName.toString() + " updated successfully. Mail has been sent.";
        }
        Swal.fire({icon: 'success',
          text: msg
        })
      }else{
        Swal.fire("Something went wrong.")
        return;
      }
      setUpdateFlag(!updateFlag);
    })
  }
  const cancelForm = (e) => {
    e.preventDefault();
    setDisplyForm(false)
  }
  const data = {
    columns: [
      {
        label: 'S.No',
        field: 'id',
      },
      {
        label: 'User Name',
        field: 'u_name',
      },
      {
        label: 'Email',
        field: 'email',
      },
      {
        label: 'Role',
        field: 'role',
      },
      {
        label: 'Create By',
        field: 'c_name',
      },
      {
        label: 'Created DateTime',
        field: 'c_date',
      },
      {
        label: 'Status',
        field: 'status',
      },
      {
        label: 'Action',
        field: 'action',
      },
    ],
    rows: accessDetails
  };
  const searchOptions = {
      text: 'Search by name', // Placeholder text for the search input
      showSearch: true, // Show the search input
      searchLabel: 'Search:', // Label for the search input
    };
  return(
      <div className='body_class'>
        {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
        ) : ("")}
          <div className='container-fluid'>
            {!DisplyForm ? (
            <>
            <div className="mt-5">
            {foundUser['tm_accessRole']['User']['Add'] == true &&
              <Button size="large" type="submit" variant="contained" onClick={handleSubmit}>
                  + Add User
              </Button>
            }
            </div>
            <div className="row mt-1">
              <div className="col-md-12">
                <MDBDataTable
                  bordered
                  data={data}
                  large={false}
                  displayEntries={false}
                  search={searchOptions}
                  noBottomColumns={true}
                  className="pagination-right-aligned"
                  searching={true}
                />
              </div>
            </div>
            </>
            ):(
              <>
              <h4>Add User</h4>
              <div className='mt-4'>
              <div className='container-fluid'>
              {/* <Form onSubmit={handleSubmitForm}>
              <div className='p-3 madatory_fields'>
                <div className="form_section">**Mandatory Fields**</div>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">
                      Company Name *
                    </Form.Label>
                    <Col sm="5">
                      <Select placeholder="Select Company" options={companyItems} onChange={handleCompanyChange} value={selectedCompany}/>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">
                      Role *
                    </Form.Label>
                    <Col sm="5">
                      <Select placeholder="Select Role" options={roleItems} value={selectedRole} onChange={handleCompanyChange2}/>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">
                      User Name *
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={userName} onChange={(e)=>setUserName(e.target.value)} placeholder='User Name' />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">
                      Email *
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='email' value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='Email'/>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                    <Form.Label column sm="2">
                      Password *
                    </Form.Label>
                    <Col sm="5">
                    <InputGroup>
                      <FormControl
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder='Password'
                      />
                      <InputGroup.Text id="password-addon">
                        <span onClick={togglePasswordVisibility}>
                          {showPassword ? <BsEye /> : <BsEyeSlash />}
                        </span>
                      </InputGroup.Text>
                    </InputGroup>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">
                      Select Locations *
                    </Form.Label>
                    <Col sm="5">
                    <Select isMulti placeholder="Select Location" options={locationItems} onChange={handleLocationChange} value={selectedLocation}/>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">
                      Select API Company *
                    </Form.Label>
                    <Col sm="5">
                    <Select isMulti placeholder="Select API Company" options={apiCompanyItems} onChange={handleApiCompanyChange} value={selectedApiComany}/>
                    </Col>
                  </Form.Group>
              </div>
              
              <div className='p-3 madatory_fields'>
                <div className="form_section">**Non Mandatory Fields**</div>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextPN">
                    <Form.Label column sm="2">
                      Phone Number
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={phoneNumber} onChange={(e)=>setPhoneNumber(e.target.value)} placeholder='Phone Number'/>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextNote">
                    <Form.Label column sm="2">
                      Note
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control as="textarea" value={note} onChange={(e)=>setNote(e.target.value)} rows={3} placeholder='Note' />
                    </Col>
                  </Form.Group>
              </div>
                  <div style={{textAlign:"center"}} className=''>
                  <Form.Group as={Row} className="mt-4" controlId="formPlaintextCheckbox">
                    <Col sm="5"></Col>
                        <Col sm="1">
                        <Form.Check
                            type="checkbox"
                            id="checkbox"
                            label="Is&nbsp;Active"
                            checked={isActive}
                            onChange={handleIsActive}
                        />
                        </Col>
                    </Form.Group>
                    {viewEditButton && 
                      <>
                      <Button variant="contained" type="submit" onClick={() => setSendMailStatus(false)}>
                        Submit
                      </Button>
                      <Button variant="contained" type="submit" className="m-4" onClick={() => setSendMailStatus(true)}>
                        Submit & Send Mail
                      </Button>
                      </>
                    }
                    <Button variant="outlined" type="submit" onClick={cancelForm}>
                      Cancel
                    </Button>
                  </div>
                </Form> */}

              {/* GTIS validation */}
              <Form onSubmit={handleSubmitForm}>
                <div className='p-3 madatory_fields'>
                  <div className="form_section">**Mandatory Fields**</div>

                  
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">Company Name *</Form.Label>
                    <Col sm="5">
                      <Select
                        placeholder="Select Company"
                        options={companyItems}
                        onChange={(selected) => {
                          handleCompanyChange(selected);
                          setErrors((prev) => ({ ...prev, company: '' }));
                        }}
                        value={selectedCompany}
                      />
                      {errors.company && <small className="text-danger d-block mt-1">{errors.company}</small>}
                    </Col>
                  </Form.Group>
              
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">Role *</Form.Label>
                    <Col sm="5">
                      <Select
                        placeholder="Select Role"
                        options={roleItems}
                        value={selectedRole}
                        onChange={(selected) => {
                          handleCompanyChange2(selected);
                          setErrors((prev) => ({ ...prev, role: '' }));
                        }}
                      />
                      {errors.role && <small className="text-danger d-block mt-1">{errors.role}</small>}
                    </Col>
                  </Form.Group>
                
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">User Name *</Form.Label>
                    <Col sm="5">
                      <Form.Control
                        type='text'
                        value={userName}
                        maxLength={40}
                        placeholder='User Name'
                        onChange={(e) => {
                          const rawValue = e.target.value;

                          // If raw value contains any invalid character:
                          if (/[^A-Za-z ]/.test(rawValue)) {
                            setErrors((prev) => ({ ...prev, userName: 'Characters & spaces are only allowed.' }));
                            return; // prevent updating state
                          }

                          // Valid value — update the state and check other conditions
                          setUserName(rawValue);

                          if(rawValue.length >= 40){
                            setErrors((prev) => ({...prev, userName: 'User name cannot exceeds 40 characters'}))
                          }
                          else if (rawValue.trim() === '') {
                            setErrors((prev) => ({ ...prev, userName: 'User name is required.' }));
                          } else if (rawValue.trim().length < 3) {
                            setErrors((prev) => ({ ...prev, userName: 'User name must be at least 3 characters.' }));
                          } else {
                            setErrors((prev) => ({ ...prev, userName: '' }));
                          }
                        }}
                      />
                      {errors.userName && <small className="text-danger d-block mt-1">{errors.userName}</small>}
                    </Col>
                  </Form.Group>
     
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">Email *</Form.Label>
                    <Col sm="5">
                      <Form.Control
                        type='email'
                        value={email}
                        maxLength={50}
                        placeholder='Email'
                        onChange={(e) => {
                          const val = e.target.value;
                          setEmail(val);

                          // Live validation
                          if(val.length >=50){
                            setErrors((prev) => ({...prev, email: 'Email cannot exceeds 50 characters.'}))
                          }
                          else if (val.trim() === '') {
                            setErrors((prev) => ({ ...prev, email: 'Email is required.' }));
                          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                            setErrors((prev) => ({ ...prev, email: 'Please enter a valid email address.' }));
                          } else {
                            setErrors((prev) => ({ ...prev, email: '' }));
                          }
                        }}
                      />
                      {errors.email && <small className="text-danger d-block mt-1">{errors.email}</small>}
                    </Col>
                  </Form.Group>
       
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                    <Form.Label column sm="2">Password *</Form.Label>
                    <Col sm="5">
                      <InputGroup>
                        <FormControl
                          type={showPassword ? 'text' : 'password'}
                          value={password}
                          maxLength={20}
                          placeholder='Password'
                          onChange={(e) => {
                            const value = e.target.value;
                            setPassword(value);

                            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
                            if(value.length >= 20){
                              setErrors((prev) => ({...prev, password: 'Password cannot exceed 20 characters'}))
                            }
                            else if (value.trim() === '') {
                              setErrors((prev) => ({ ...prev, password: 'Password is required.' }));
                            } else if (!passwordRegex.test(value)) {
                              setErrors((prev) => ({ ...prev, password: 'Must have uppercase, lowercase, special char, ≥8 chars.' }));
                            } else {
                              setErrors((prev) => ({ ...prev, password: '' }));
                            }
                          }}
                         
                        />
                        <InputGroup.Text id="password-addon">
                          <span onClick={togglePasswordVisibility}>{showPassword ? <BsEye /> : <BsEyeSlash />}</span>
                        </InputGroup.Text>
                      </InputGroup>
                      {errors.password && <small className="text-danger d-block mt-1">{errors.password}</small>}
                    </Col>
                  </Form.Group>
           
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextLocations">
                    <Form.Label column sm="2">Select Locations *</Form.Label>
                    <Col sm="5">
                      <Select
                        isMulti
                        options={options}
                        value={selectedLocation}
                        onChange={(selected) => {
                          // if user picked "ALL"
                          if (selected.some((opt) => opt.value === "ALL")) {
                            // setSelectedLocation(locationItems); // select all
                            handleLocationChange(locationOptions);
                            setErrors((prev) => ({ ...prev, locations: '' }));
                          } else {
                            handleLocationChange(selected || []);
                          }
                        }}
                      />
                      {errors.locations && (
                        <small className="text-danger d-block mt-1">{errors.locations}</small>
                      )}
                    </Col>
                  </Form.Group>

        
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                  <Form.Label column sm="2">Select API Company *</Form.Label>
                  <Col sm="5">
                    <Select
                      isMulti
                      placeholder="Select API Company"
                      options={apiCompanyOptions}
                      value={selectedApiComany}
                      onChange={(selected) => {
                        if (selected.some((opt) => opt.value === "ALL")) {
                          // ✅ User picked "Select All"
                          handleApiCompanyChange(apiCompanyItems); // select all companies
                          setErrors((prev) => ({ ...prev, apiCompany: '' }));
                        } else {
                          // ✅ Otherwise set the selected companies normally
                          handleApiCompanyChange(selected || []);
                          setErrors((prev) => ({ ...prev, apiCompany: '' }));
                        }
                      }}
                    />
                    {errors.apiCompany && <small className="text-danger d-block mt-1">{errors.apiCompany}</small>}
                  </Col>
                </Form.Group>
                </div>

                
                <div className='p-3 madatory_fields'>
                  <div className="form_section">**Non Mandatory Fields**</div>

                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextPN">
                    <Form.Label column sm="2">Phone Number</Form.Label>
                      <Col sm="5">
                        <Form.Control
                          type='text'
                          value={phoneNumber}
                          placeholder='Phone Number'
                          maxLength={15}
                          onChange={(e) => {
                            const rawVal = e.target.value;

                            // Check if they typed anything not a digit
                            if (/[^0-9]/.test(rawVal)) {
                              setErrors(prev => ({ ...prev, phoneNumber: 'Phone number can only contain digits.' }));
                            } else {
                              // Only digits so continue
                              setPhoneNumber(rawVal);

                              if (rawVal.length >= 15) {
                                setErrors(prev => ({ ...prev, phoneNumber: 'Phone number cannot exceed 15 digits.' }));
                              } else if (rawVal.length < 7) {
                                setErrors(prev => ({ ...prev, phoneNumber: 'Phone number must be at least 7 digits.' }));
                              } else {
                                setErrors(prev => ({ ...prev, phoneNumber: '' }));
                              }
                            }
                          }}
                        />
                        {errors.phoneNumber && (
                          <small className="text-danger d-block mt-1">{errors.phoneNumber}</small>
                        )}
                      </Col>
                  </Form.Group>


                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextNote">
                    <Form.Label column sm="2">Note</Form.Label>
                    <Col sm="8">
                      <Form.Control
                        as="textarea"
                        value={note}
                        placeholder='Note'
                        onChange={(e) => setNote(e.target.value)}
                        rows={3}
                      />
                    </Col>
                  </Form.Group>
                </div>

               
                <div style={{ textAlign: "center" }} className=''>
                  <Form.Group as={Row} className="mt-4" controlId="formPlaintextCheckbox">
                    <Col sm="5"></Col>
                    <Col sm="1">
                      <Form.Check
                        type="checkbox"
                        id="checkbox"
                        label="Is Active"
                        checked={isActive}
                        onChange={handleIsActive}
                      />
                    </Col>
                  </Form.Group>
                  {viewEditButton && (
                    <>
                      <Button variant="contained" type="submit" onClick={() => setSendMailStatus(false)}>
                        Submit
                      </Button>
                      <Button variant="contained" className="m-4" type="submit" onClick={() => setSendMailStatus(true)}>
                        Submit & Send Mail
                      </Button>
                    </>
                  )}
                  <Button variant="outlined" type="submit" onClick={cancelForm}>Cancel</Button>
                </div>
              </Form> 
              </div>
              </div>
              </>
            )}
          </div>
      </div>
    )
}

export default User;